import React from "react";
import {
    Badge
} from 'reactstrap';
class ActionTypeBadge extends React.Component {
    render() {
        let { data } = this.props;
        return (
            <Badge color='info'>&nbsp;{data.Name}&nbsp;</Badge>
    )
    }
}
export default ActionTypeBadge;



// WEBPACK FOOTER //
// ./src/views/workflow/action-type-badge.js